// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DashboardList .JobsWithZaiUseCases-sortAndFilters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 var(--spacing_unit_5);
}
.DashboardList h2 {
  margin-bottom: 24px;
  font-size: 24px;
  font-weight: 700;
}
.DashboardList .JobsWithZaiUseCases-sort {
  flex: 1 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: var(--spacing_unit_3);
}
.DashboardList .JobsWithZaiUseCases-filters {
  display: flex;
  gap: var(--spacing_unit_3);
}
.DashboardList .SortByFilterV2 {
  margin: 0;
}
.DashboardList .input-action-container {
  margin: 0 0 var(--spacing_unit_5);
}
.DashboardList .boards-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 20.5px;
  margin-bottom: 56px;
}
.DashboardList .boards-grid .notAllowed {
  height: 200px;
}
@media screen and (min-width: 768px) {
  .DashboardList .boards-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media screen and (min-width: 490px) and (max-width: 767px) {
  .DashboardList .boards-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
.DashboardList .DashboardListEmptyState {
  margin-bottom: 24px;
}
.DashboardList .BlockClickTooltip {
  height: 200px;
}`, "",{"version":3,"sources":["webpack://./src/modules/dashboard/dashboard-list/dashboard-list.styles.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iCAAA;AAAJ;AAGE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AADJ;AAIE;EACE,SAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,0BAAA;AAFJ;AAKE;EACE,aAAA;EACA,0BAAA;AAHJ;AAME;EACE,SAAA;AAJJ;AAOE;EACE,iCAAA;AALJ;AAQE;EACE,aAAA;EACA,qCAAA;EACA,gBAAA;EACA,mBAAA;AANJ;AAQI;EACE,aAAA;AANN;AASI;EAVF;IAWI,qCAAA;EANJ;AACF;AAQI;EAdF;IAeI,qCAAA;EALJ;AACF;AAQE;EACE,mBAAA;AANJ;AASE;EACE,aAAA;AAPJ","sourcesContent":[".DashboardList {\n  .JobsWithZaiUseCases-sortAndFilters {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 0 0 var(--spacing_unit_5);\n  }\n\n  h2 {\n    margin-bottom: 24px;\n    font-size: 24px;\n    font-weight: 700;\n  }\n\n  .JobsWithZaiUseCases-sort {\n    flex: 1;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: var(--spacing_unit_3);\n  }\n\n  .JobsWithZaiUseCases-filters {\n    display: flex;\n    gap: var(--spacing_unit_3);\n  }\n\n  .SortByFilterV2 {\n    margin: 0;\n  }\n\n  .input-action-container {\n    margin: 0 0 var(--spacing_unit_5);\n  }\n\n  .boards-grid {\n    display: grid;\n    grid-template-columns: repeat(1, 1fr);\n    grid-gap: 20.5px;\n    margin-bottom: 56px;\n\n    .notAllowed {\n      height: 200px;\n    }\n\n    @media screen and (min-width: 768px) {\n      grid-template-columns: repeat(4, 1fr);\n    }\n\n    @media screen and (min-width: 490px) and (max-width: 767px) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n\n  .DashboardListEmptyState {\n    margin-bottom: 24px;\n  }\n\n  .BlockClickTooltip {\n    height: 200px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
